export const enum EdsDataTypes {
  Alphanumeric = 'Alphanumeric',
  Integer = 'Integer',
  YesNo = 'Yes/No',
  Boolean = 'Boolean',
  Long = 'Long',
  Age = 'Age',
  Currency = 'Currency',
  Date = 'Date',
  DateTime = 'Date/Time',
  SocialSecurityNumber = 'Social Security Number',
  SocialInsuranceNumber = 'Social Insurance Number',
  TaxIdentificationNumber = 'Tax Identification Number',
  PercentageInt = 'Percentage Int',
  Percentage = 'Percentage',
  Phone = 'Phone',
  Email = 'Email',
  Year = 'Year',
  DataTable = 'DataTable',
}
